import type { BossDefinition } from './types';

/**
 * Each player brings three of these into a match. Every 90 seconds one of
 * them is chosen at random and sent down a random lane. The two sides pick
 * independently, so the bosses may share a lane or miss each other.
 * Health and damage grow with time, and with the minions that vanish as the boss steps onto the field.
 */
export const BOSS_ROSTER: BossDefinition[] = [
  {
    id: 'warden',
    name: 'The Warden',
    time: 0,
    hp: 1,
    damage: 1,
    attackInterval: 1.05,
    speed: 22,
    leak: 2,
    scale: 1.75,
    laneRule: 'random',
    faction: 'sand',
    hpScale: 1.28,
    damageScale: 0.82,
    description: 'A heavy walker. It soaks the other boss and keeps coming.',
    aura: { label: '+10% minion health', minionHp: 0.1 },
  },
  {
    id: 'splitter',
    name: 'The Splitter',
    time: 0,
    hp: 1,
    damage: 1,
    attackInterval: 0.85,
    speed: 34,
    leak: 2,
    scale: 1.55,
    laneRule: 'random',
    faction: 'red',
    hpScale: 0.82,
    damageScale: 1.08,
    description: 'Fast. It reaches the duel first.',
    aura: { label: 'minions move 8% faster', minionSpeed: 0.08 },
  },
  {
    id: 'siegebreaker',
    name: 'The Siegebreaker',
    time: 0,
    hp: 1,
    damage: 1,
    attackInterval: 1.1,
    speed: 26,
    leak: 2,
    scale: 1.7,
    laneRule: 'random',
    faction: 'purple',
    hpScale: 1,
    damageScale: 1.28,
    description: 'Hits harder than the army that birthed it.',
    aura: { label: '+8% tower damage', towerDamage: 0.08 },
  },
  {
    id: 'pyreheart',
    name: 'The Pyreheart',
    time: 0,
    hp: 1,
    damage: 1,
    attackInterval: 0.95,
    speed: 30,
    leak: 2,
    scale: 1.6,
    laneRule: 'random',
    faction: 'gold',
    hpScale: 0.9,
    damageScale: 1.18,
    description: 'A burning core. More damage, less hide.',
    aura: { label: '+10% minion damage', minionDamage: 0.1 },
  },
  {
    id: 'groveward',
    name: 'The Groveward',
    time: 0,
    hp: 1,
    damage: 1,
    attackInterval: 1,
    speed: 24,
    leak: 2,
    scale: 1.65,
    laneRule: 'random',
    faction: 'green',
    hpScale: 1.18,
    damageScale: 0.92,
    description: 'Thick and slow. It outlasts a thinner boss.',
    aura: { label: 'muster 8% faster', spawnRate: 0.08 },
  },
  {
    id: 'frostjaw',
    name: 'The Frostjaw',
    time: 0,
    hp: 1,
    damage: 1,
    attackInterval: 0.9,
    speed: 28,
    leak: 2,
    scale: 1.6,
    laneRule: 'random',
    faction: 'blue',
    hpScale: 1.05,
    damageScale: 1,
    description: 'A balanced hunter. It meets the other boss in the middle.',
    aura: { label: 'towers fire 8% faster', fireRate: 0.08 },
  },
];

export const BOSS_BY_ID: Record<string, BossDefinition> = Object.fromEntries(BOSS_ROSTER.map((b) => [b.id, b]));

/** @deprecated Scheduled bosses were replaced by the 50-second duel. */
export const BOSSES = BOSS_ROSTER;
